import { DROP_PREVIEW_EVENT_PAGE_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import dropEventBase from 'root/src/client/logic/dropEvent/util/dropEventBase'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import updateEvent from 'root/src/client/logic/dropEvent/actions/updateEvent'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import omit from 'ramda/src/omit'

export default formData => async (dispatch, getState) => {
	const state = getState()
	const { endpointId, dropEventPayload } = await dropEventBase({ formData, dispatch, getState })
	const { listStoreKey, ...payload } = dropEventPayload
	const { body, error } = await invokeApiRequest(endpointId, { dropEventPayload: omit(['approved'], payload) }, state)

	if (error) {
		throw error
	}

	dispatch(updateEvent({ ...body, listStoreKey }))
	return pushRouteClient({
		routeId: DROP_PREVIEW_EVENT_PAGE_ROUTE_ID,
		routeParams: { recordId: body.mnemonicId },
	})
}
